import {faqConstants} from "../../../../constants/Web/faq.constants";

const initialState = {
    fetching: false,
    listData: [],
    listDataError: false,

    detailFetching: false,
    detailData: null,
    detailError: false,

    createFaqFetching: false,
    createFaq: [],
    createFaqError: false,

    updateFaqFetching: false,
    updateFaq: [],
    updateFaqError: false,

    deleteFaqFetching: false,
    deleteFaq: [],
    deleteFaqError: false,

    sortFaqFetching: false,
    sortFaq: [],
    sortFaqError: false,

    translateFetching: false,
    translateData: null,
    translateError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case faqConstants.FAQ_LIST_PENDING:
            return {
                ...state,
                fetching: true,
            };
        case faqConstants.FAQ_LIST_FULFILLED:
            return {
                ...state,
                fetching: false,
                listDataError: false,
                listData: action.payload,
            };
        case faqConstants.FAQ_LIST_REJECTED:
            return {
                ...state,
                fetching: false,
                listDataError: action.payload,
            };

        case faqConstants.FAQ_DETAIL_PENDING:
            return {
                ...state,
                detailFetching: true,
                detailError: false,
            };
        case faqConstants.FAQ_DETAIL_FULFILLED:
            return {
                ...state,
                detailFetching: false,
                detailError: false,
                detailData: action.payload,
            };
        case faqConstants.FAQ_DETAIL_REJECTED:
            return {
                ...state,
                detailFetching: false,
                detailError: action.payload,
            };
        case faqConstants.FAQ_DETAIL_CLEAR:
            return {
                ...state,
                detailFetching: false,
                detailData: null,
                detailError: false,
            };

        case faqConstants.CREATE_FAQ_PENDING:
            return {
                ...state,
                createFaqFetching: true,
            };
        case faqConstants.CREATE_FAQ_FULFILLED:
            return {
                ...state,
                createFaqFetching: false,
                createFaqError: false,
                createFaq: action.payload,
            };
        case faqConstants.CREATE_FAQ_REJECTED:
            return {
                ...state,
                createFaqFetching: false,
                createFaqError: action.payload,
            };
        case faqConstants.CREATE_FAQ_CLEAR:
            return {
                ...state,
                createFaqFetching: false,
                createFaq: [],
                createFaqError: false,
            };

        case faqConstants.UPDATE_FAQ_PENDING:
            return {
                ...state,
                updateFaqFetching: true,
            };
        case faqConstants.UPDATE_FAQ_FULFILLED:
            return {
                ...state,
                updateFaqFetching: false,
                updateFaqError: false,
                updateFaq: action.payload,
            };
        case faqConstants.UPDATE_FAQ_REJECTED:
            return {
                ...state,
                updateFaqFetching: false,
                updateFaqError: action.payload,
            };
        case faqConstants.UPDATE_FAQ_CLEAR:
            return {
                ...state,
                updateFaqFetching: false,
                updateFaq: [],
                updateFaqError: false,
            };

        case faqConstants.DELETE_FAQ_PENDING:
            return {
                ...state,
                deleteFaqFetching: true,
            };
        case faqConstants.DELETE_FAQ_FULFILLED:
            return {
                ...state,
                deleteFaqFetching: false,
                deleteFaqError: false,
                deleteFaq: action.payload,
            };
        case faqConstants.DELETE_FAQ_REJECTED:
            return {
                ...state,
                deleteFaqFetching: false,
                deleteFaqError: action.payload,
            };
        case faqConstants.DELETE_FAQ_CLEAR:
            return {
                ...state,
                deleteFaqFetching: false,
                deleteFaq: [],
                deleteFaqError: false,
            };

        case faqConstants.SORT_FAQ_PENDING:
            return {
                ...state,
                sortFaqFetching: true,
            };
        case faqConstants.SORT_FAQ_FULFILLED:
            return {
                ...state,
                sortFaqFetching: false,
                sortFaqError: false,
                sortFaq: action.payload,
            };
        case faqConstants.SORT_FAQ_REJECTED:
            return {
                ...state,
                sortFaqFetching: false,
                sortFaqError: action.payload,
            };
        case faqConstants.SORT_FAQ_CLEAR:
            return {
                ...state,
                sortFaqFetching: false,
                sortFaq: [],
                sortFaqError: false,
            };

        case faqConstants.TRANSLATE_FAQ_PENDING:
            return {
                ...state,
                translateFetching: true,
                translateData: null,
                translateError: false,
            };
        case faqConstants.TRANSLATE_FAQ_FULFILLED:
            return {
                ...state,
                translateFetching: false,
                translateError: false,
                translateData: action.payload,
            };
        case faqConstants.TRANSLATE_FAQ_REJECTED:
            return {
                ...state,
                translateFetching: false,
                translateError: action.payload,
            };
        case faqConstants.TRANSLATE_FAQ_CLEAR:
            return {
                ...state,
                translateFetching: false,
                translateData: null,
                translateError: false,
            };

        case "CLEAR_STATE":
            return {
                ...initialState
            };
        default:
            return state;
    }
}
